import useResizeObserver from '@react-hook/resize-observer'
import ProjectHeaderContainer from 'components/Project/shared/ProjectHeader/ProjectHeaderContainer'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import { themeClassName } from 'helpers/Project'
import PropTypes from 'prop-types'
import { useRef } from 'react'

import CompletedProject from './CompletedProject/CompletedProject'
import Project from './Project/Project'
import { NoPrint } from 'components/shared/NoPrint/NoPrint'
const CompletedOrProject = ({
  locale,
  project,
  projectComplete,
  projectSlug,
  progressCallback,
}) => {
  const mainRef = useRef(null)

  useResizeObserver(mainRef, () => {
    if (projectComplete) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  })

  return (
    <div className={`c-project ${themeClassName(project.theme)}`} ref={mainRef}>
      <NoPrint>
        <header className="c-project__header">
          <ProjectHeaderContainer projectComplete={projectComplete} />
        </header>
      </NoPrint>
      {projectComplete ? (
        <>
          <HtmlHead
            title={`${project.title} | Complete`}
            image={project.heroImage}
          />
          <CompletedProject locale={locale} projectSlug={projectSlug} />
        </>
      ) : (
        <Project
          locale={locale}
          project={project}
          progressCallback={progressCallback}
        />
      )}
    </div>
  )
}

CompletedOrProject.propTypes = {
  locale: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
  projectComplete: PropTypes.bool.isRequired,
  projectSlug: PropTypes.string.isRequired,
  progressCallback: PropTypes.func.isRequired,
}

export default CompletedOrProject
